// extracted by mini-css-extract-plugin
export default {"root":"LoadingModal_root__YqyPj","loader":"LoadingModal_loader__gwEr0"};